export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const RESET_PWD_TOKEN = 'resetPwdToken';
export const IMPERSONATE_TOKEN = 'impersonateToken';
export const LOCATION_BEFORE_IMPERSONATION = 'locationBeforeImpersonation';
export const LOCATION_BEFORE_SESSION_EXPIRATION =
  'locationBeforeSessionExpiration';
export const EMPLOYEE_ID = 'employeeId';
